// extracted by mini-css-extract-plugin
module.exports = {"root":"MisclassificationsNoAccess_root__12slk","logo":"MisclassificationsNoAccess_logo__3q3xu"};